import { render } from "./NewEmployee.vue?vue&type=template&id=044f79ca&scoped=true"
import script from "./NewEmployee.vue?vue&type=script&lang=js"
export * from "./NewEmployee.vue?vue&type=script&lang=js"

import "./NewEmployee.vue?vue&type=style&index=0&id=044f79ca&scoped=true&lang=css"

import exportComponent from "/Users/onisiforosgeorgiou/WebstormProjects/AgencyNow/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-044f79ca"]])

export default __exports__